import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { cn } from "@/lib/utils";

/**
 * Dialog Description Component
 * Additional descriptive text for the dialog
 */
export const DialogDescription = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Description>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Description>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Description
    ref={ref}
    className={cn("text-sm", className)}
    style={{ color: 'var(--color-text-muted, #6b7280)', ...props.style }}
    {...props}
  />
));

DialogDescription.displayName = DialogPrimitive.Description.displayName;

